// app/javascript/controllers/accordion_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const button = event.currentTarget
    const content = button.nextElementSibling
    const icon = button.querySelector("svg")

    content.classList.toggle("hidden")
    icon.classList.toggle("rotate-180")
  }
}
